import { Navigate, Outlet } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useAppSelector } from "@store/hooks";

const RequireAuth = () => {
  const userId = useAppSelector((state) => state.user.userId);
  const authChecked = useAppSelector((state) => state.auth.authChecked);
  // Post-login, authChecked is true but userId isn't set until the AAL/MFA
  // gate + bootstrap finish. Wait on that rather than redirecting to "/" —
  // otherwise a navigation in that window bounces back to the landing page
  // (and only a refresh, which restores the session before render, fixes it).
  const authResolving = useAppSelector((state) => state.auth.authResolving);

  if (!authChecked || authResolving) {
    return (
      <Box
        role="status"
        aria-label="Checking authentication"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!userId) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
